var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1),_c('BottomPane',{attrs:{"id":'add'}},[_c('addItem')],1),(_vm.$store.state.currentNotification.toggle === true)?_c('Notification'):_vm._e(),_c('TabBar')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }